var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 100,
    viewBox: "0 0 112 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Hide"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hide"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3548 61.5596C44.4801 61.5596 43.6054 61.2271 42.9403 60.5574C39.5783 57.2 37.7242 52.7355 37.7242 47.9886C37.7242 38.1486 45.7238 30.1445 55.5546 30.1445C60.2833 30.1445 64.8753 32.0533 68.1508 35.3834C69.4719 36.7319 69.4582 38.8912 68.1098 40.2123C66.7659 41.5425 64.6065 41.5198 63.2809 40.1804C61.281 38.1441 58.4656 36.9779 55.5546 36.9779C49.4912 36.9779 44.5575 41.9161 44.5575 47.9886C44.5575 50.9088 45.701 53.6603 47.7692 55.7285C49.104 57.0633 49.104 59.2226 47.7738 60.5574C47.1041 61.2271 46.2294 61.5596 45.3548 61.5596Z",
    fill: "#6F8EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1404 65.5413C56.5232 65.5413 55.0836 64.3842 54.7829 62.7351C54.4458 60.881 55.6758 59.0998 57.5345 58.7626C61.9989 57.9518 65.5341 54.4075 66.3358 49.9385C66.6729 48.0844 68.4496 46.8635 70.3037 47.1824C72.1624 47.515 73.3969 49.2916 73.0644 51.1503C71.7569 58.4073 66.0078 64.1655 58.7554 65.4866C58.5504 65.5231 58.3408 65.5413 58.1404 65.5413Z",
    fill: "#6F8EF5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2704_7715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 74,
    height: 65
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.4819H83.2817V75.7067H10V11.4819Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2704_7715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2033 75.7067C30.4653 75.7067 29.7227 75.4653 29.0941 74.9778C21.3906 68.9281 14.8807 60.0584 10.2796 49.3346C9.90606 48.4691 9.90606 47.4942 10.2796 46.6332C14.9308 35.8638 21.4817 26.9486 29.2262 20.8578C45.0157 8.36196 66.0351 8.32096 81.9841 20.949C83.4646 22.1197 83.7152 24.27 82.5444 25.7505C81.3691 27.222 79.228 27.4816 77.7428 26.3063C64.2311 15.6098 46.8243 15.6463 33.4583 26.2243C26.9165 31.3721 21.2995 38.8705 17.154 47.9907C21.2585 57.0563 26.8254 64.5092 33.3171 69.6023C34.8022 70.7685 35.0573 72.9187 33.8911 74.3993C33.2168 75.2557 32.2146 75.7067 31.2033 75.7067Z",
    fill: "#6F8EF5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2704_7715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 30,
    width: 62,
    height: 55
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6018 30.2358H101.111V84.6665H40.6018V30.2358Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2704_7715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.556 84.6665C51.2875 84.6665 47.0417 83.9741 42.9417 82.612C41.1514 82.0152 40.181 80.0791 40.7778 78.2888C41.3746 76.4939 43.3016 75.5418 45.101 76.1249C48.504 77.2592 52.0209 77.8332 55.556 77.8332C71.1725 77.8332 85.445 66.7085 93.9594 47.9807C91.882 43.4297 89.463 39.3069 86.757 35.708C85.6227 34.2001 85.9233 32.0544 87.4312 30.9201C88.9346 29.7858 91.0802 30.0956 92.2146 31.5989C95.5128 35.9768 98.4101 41.038 100.829 46.6231C101.207 47.4887 101.207 48.4727 100.829 49.3337C91.2807 71.46 74.3568 84.6665 55.556 84.6665Z",
    fill: "#6F8EF5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2704_7715",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 8,
    width: 79,
    height: 80
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2117 8.63867H94.9021V87.3268H16.2117V8.63867Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2704_7715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6273 87.3268C18.7526 87.3268 17.8779 86.9942 17.2128 86.3246C15.878 84.9898 15.878 82.8304 17.2128 81.4957L89.0722 9.63634C90.4069 8.30156 92.5663 8.30156 93.901 9.63634C95.2358 10.9711 95.2358 13.135 93.901 14.4698L22.0417 86.3246C21.3766 86.9942 20.5019 87.3268 19.6273 87.3268Z",
    fill: "#6F8EF5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.c53bf5e0bf4329c8ade8f1e098383d91.svg";
export { ForwardRef as ReactComponent };